import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./Drinks.css";

const menuData = {
  Beer: {
    Domestic: {
      subtitle: "",
      items: [
        ["Coors Light", "$4.75"],
        ["Bud Light", "$3.75"],
        ["Budweiser", "$3.75"],
      ],
    },

    Imported: {
      subtitle: "$4.75 / bottle",
      items: [
        ["Heineken"],
        ["Corona"],
        ["Sapporo"],
        ["Modelo"],
        ["Kirin"],
        ["Asahi"],
        ["Tsingtao"],
      ],
    },
  },

  Wine: {
    "House Wine": {
      subtitle: "$5.75 glass • $16.99 bottle",
      items: [
        ["Merlot"],
        ["Cabernet"],
        ["Chardonnay"],
        ["Pinot Noir"],
        ["White Zinfandel"],
      ],
    },

    "Sweet Wine": {
      subtitle: "$6.95 glass • $18.99 bottle",
      items: [["Plum Wine"], ["Stella Rosa"], ["Kungfu Girl"]],
    },
  },

  "Sake / Soju": {
    Sake: {
      subtitle: "",
      items: [
        ["Hot Sake", "$12.95"],
        ["Cold Sake", "$12.95"],
      ],
    },

    Soju: {
      subtitle: "$11.95 / bottle",
      items: [
        ["Regular"],
        ["Fresh"],
        ["Peach"],
        ["Apple"],
        ["Green Grape"],
        ["Strawberry"],
        ["Watermelon"],
        ["Lychee"],
        ["Mango"],
        ["Plum"],
      ],
    },
  },

  "Non-Alcohol": {
    Fountain: {
      subtitle: "$2.85 with free refills",
      items: [
        ["Pepsi"],
        ["Diet Pepsi"],
        ["Starry"],
        ["Dr Pepper"],
        ["Mountain Dew"],
        ["Orange Crush"],
        ["Root Beer"],
        ["Lemonade"],
        ["Sweet Tea"],
        ["Raspberry Tea"],
        ["Unsweet Tea"],
        ["Iced Tea"],
        ["Club Soda"],
      ],
    },

    Other: {
      subtitle: "",
      items: [
        ["Apple Juice", "$3.85"],
        ["Orange Juice", "$3.85"],
        ["Coffee", "$2.45"],
        ["Hot Tea", "$2.45"],
        ["Fridge Drinks", "$2.85"],
        ["Ramune", "$3.99"],
      ],
    },
  },
};

const Drinks = () => {
  const tabs = Object.keys(menuData);

  const [activeTab, setActiveTab] = useState("Beer");

  return (
    <>
      <Helmet>
        <title>Drink Menu | Hiro Japanese Buffet & Arcade</title>

        <meta
          name="description"
          content="Explore Hiro Japanese Buffet's drink menu including domestic and imported beers, wines, sake, and non-alcoholic options."
        />

        <meta
          name="keywords"
          content="Hiro Buffet drinks, Japanese buffet drinks, sake, beer, wine, soft drinks"
        />

        <link
          rel="canonical"
          href="https://www.hirojapanesebuffet.com/drinks"
        />
      </Helmet>

      <div className="drinks-page">
        <div className="drinks-overlay" />

        <section className="drinks-content">
          <h1 className="drinks-title">DRINKS</h1>

          <div className="drink-tabs">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={activeTab === tab ? "active" : ""}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="drinks-menu-card">
            {Object.entries(menuData[activeTab]).map(
              ([sectionTitle, section]) => (
                <div className="drink-section" key={sectionTitle}>
                  <h2>{sectionTitle}</h2>

                  {section.subtitle && (
                    <p className="drink-subtitle">{section.subtitle}</p>
                  )}

                  <div className="drink-items">
                    {section.items.map(([name, price]) => (
                      <div className="drink-row" key={name}>
                        <span>{name}</span>

                        {price && <span>{price}</span>}
                      </div>
                    ))}
                  </div>
                </div>
              ),
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default Drinks;
